<template>
  <memlist-card>

    <div class="d-flex justify-end">
      <memlist-icon-button
        class="mb-2"
        icon="menu-icon flaticon2-plus"
        :text="'Ladda upp fil'"
        variant="primary"
        @click="onUploadFileClicked"
      />
    </div>

    <table class="table table-head-custom table-vertical-center table-head-bg table-borderless">
      <thead>
        <tr class="text-left">
          <th style="min-width: 110px">Namn</th>
          <th style="min-width: 110px">Datum</th>
          <th style="min-width: 140px">Beskrivning</th>
          <th style="min-width: 110px">Summa</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(item, i) in files">
          <GrantFileTableRow
            v-bind:key="i"
            :file="item"
            :type="type"
            :currentCompanyId="currentCompanyId"
            @downloadFileClicked="downloadFileClicked"
            @selectFileClicked="selectFileClicked"
            @deleteFileClicked="deleteFileClicked"
            @onSumUpdated="onSumUpdated"
            @onDescrUpdated="onDescrUpdated"

            @toastr="toastr"
          />
        </template>
      </tbody>
    </table>
  </memlist-card>
</template>

<script>
import axios from 'axios';
import GrantFileTableRow from '@/view/pages/ml/grantwizard/GrantFileTableRow.vue';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

export default {
  name: 'GrantFileTable',
  props: {
    files: Array,
    currentCompanyId: String,
    type: String,
    taskStatus: {type: String, default: 'CLOSE'}
  },
  emits: ['downloadFileClicked', 'selectFileClicked', 'deleteFileClicked', 'onSumUpdated', 'onDescrUpdated', 'onUploadFileClicked'],
  components: {
    GrantFileTableRow
  },
  watch: {
    files(newValue, oldvalue) {

    }
  },
  mounted() {

  },
  methods: {
    downloadFileClicked(file_id) {
      this.$emit('downloadFileClicked', file_id);
    },
    selectFileClicked(file_id) {
      this.$emit('selectFileClicked', file_id);
    },
    deleteFileClicked(file_id) {
      this.$emit('deleteFileClicked', file_id);
    },
    onUploadFileClicked() {
      this.$emit('onUploadFileClicked');
    },
    onSumUpdated(file_id, amount) {
      this.$emit('onSumUpdated', file_id, amount);
    },
    onDescrUpdated(file_id, descr) {
      this.$emit('onDescrUpdated', file_id, descr);
    },

  },
  data() {
    return {
      list: []
    };
  }
};
</script>
